import api from "./client";

export const authApi = {
  login: (credentials) => api.post("/auth/token/", credentials),
  refresh: (refresh) => api.post("/auth/token/refresh/", { refresh }),
  me: () => api.get("/auth/me/"),
};



